import {mapActions, mapGetters} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {CONFIG} from "../../../config";

const facetMixin = {
    props: {
        facet: Object
    },

    setup() {
        const router = useRouter()
        const route = useRoute()
        return {router, route};
    },

    data() {
        return {
            isExclusiveFacet: false
        };
    },

    computed: {
        ...mapGetters({
            activeFacets: 'search/activeFacets'
        })
    },

    methods: {
        ...mapActions({
            _toggleFacet: 'search/toggleFacet'
        }),

        toggleFacet() {
            this._toggleFacet({id: this.facet.id, exclusive: this.isExclusiveFacet}).then(() => {
                if (!CONFIG._has_url_hash) {
                    return;
                }

                const facets = {};

                for (let group in this.activeFacets) {
                    facets[`mgt-filters[${group}]`] = this.activeFacets[group].join('!,')
                }

                this.$router.push({
                    name: 'mgt',
                    query: facets
                });
            })
        }
    }
}

export {facetMixin}